import React from 'react';

import { Pressable } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';
import type { ViewStyle } from 'react-native';

import { Box, Typography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { layout, primitive } from 'styles/constants';

const styles = StyleSheet.create({
  productCardOptionSeparator: {
    backgroundColor: primitive.$blackOpacity10,
    height: 1,
    width: layout.full,
  },
  productCardOptionsContainer: {
    alignItems: 'center',
    flexGrow: 1,
    overflow: 'hidden',
    width: layout.full,
  },
});

const createBox = (baseStyle: ViewStyle) => ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [baseStyle, style] });

export const ProductCardOptionSeparator = createBox(styles.productCardOptionSeparator);

export const ProductCardOptionsContainer = createBox(styles.productCardOptionsContainer);

export const ProductCardOption = Pressable.withConfig<{ $isSelected?: boolean }>(
  ({ $isSelected }) => ({
    flex: 1,
    width: 'full',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: $isSelected ? primitive.$bbqBrown : 'transparent',
  })
);

export const ProductCardOptionText = ({
  $isSelected,
  ...props
}: React.ComponentPropsWithoutRef<typeof Typography> & { $isSelected?: boolean }) =>
  React.createElement(Typography, {
    color: $isSelected ? primitive.$white : primitive.$bbqBrown,
    ...props,
  });
